/*jshint esversion: 6 */

import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Home from "./views/Home.vue";
import Identity from "./views/Identity.vue";
import Confirmation from "./views/Confirmation.vue";
import Parents from "./views/Parents.vue";
import Administration from "./views/Administration.vue";
import Send from "./views/Send.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [{
      path: "/",
      name: "login",
      component: Login,
    },
    {
      path: "/home",
      name: "home",
      component: Home,
    },
    {
      path: "/send",
      name: "send",
      component: Send,
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/identity",
      name: "identity",
      component: Identity,
    },
    {
      path: "/confirmation",
      name: "confirmation",
      component: Confirmation,
    },
    {
      path: "/parents/:token",
      name: "parents",
      component: Parents,
    },
    {
      path: "/admin",
      name: "admin",
      component: Administration,
    },
  ],

});